import {
  Container,
  Header,
  Box,
  Button,
  SpaceBetween,
  StatusIndicator,
  ExpandableSection,
} from '@cloudscape-design/components';
import { useNavigate } from 'react-router';
import { clearCredentials } from '../api/auth';

interface ErrorStateProps {
  title: string;
  message: string;
  details?: string;
  variant: 'not-found' | 'api-error' | 'auth-expired';
  onRetry?: () => void;
  backLabel?: string;
  backHref?: string;
}

export function ErrorState({
  title,
  message,
  details,
  variant,
  onRetry,
  backLabel,
  backHref,
}: ErrorStateProps) {
  const navigate = useNavigate();

  const handleReauth = () => {
    clearCredentials();
    window.location.reload();
  };

  return (
    <Container header={<Header variant="h2">{title}</Header>}>
      <Box textAlign="center" padding={{ top: 'l', bottom: 'l' }}>
        <SpaceBetween size="m" alignItems="center">
          <StatusIndicator type={variant === 'auth-expired' ? 'warning' : 'error'}>
            {message}
          </StatusIndicator>

          {details && (
            <ExpandableSection headerText="Technical details" variant="footer">
              <Box variant="code" fontSize="body-s">
                {details}
              </Box>
            </ExpandableSection>
          )}

          <SpaceBetween direction="horizontal" size="xs">
            {onRetry && <Button onClick={onRetry}>Retry</Button>}
            {backLabel && backHref && (
              <Button variant="link" onClick={() => navigate(backHref)}>
                {backLabel}
              </Button>
            )}
            {variant === 'auth-expired' && (
              <Button variant="primary" onClick={handleReauth}>
                Re-authenticate
              </Button>
            )}
          </SpaceBetween>
        </SpaceBetween>
      </Box>
    </Container>
  );
}
